import useSWR from 'swr';
import { errorInterceptor } from '@/src/utils/errorHelper';
import projectsApi from '@/src/lib/projectsApi';

type Props = {
  shouldFetch: boolean | false;
  vesselId: string;
};

export default function useBadgesForVessel({ shouldFetch, vesselId }: Props) {
  const { data, error, isLoading } = useSWR(
    shouldFetch ? ['api/vessels/{vesselId}/badges', vesselId] : '',
    // url is not used, but is needed for the cache key
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    () =>
      projectsApi.getBadgesForVessel({
        vesselId,
      }),
    {
      revalidateOnFocus: false,
      onSuccess: (data) => {
        localStorage.setItem('badges', JSON.stringify(data));
      },
      onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
        // Never retry on 404.
        const err = errorInterceptor(error);
        if (err?.status === 404) return;

        // Only retry up to five times.
        if (retryCount >= 5) return;

        // Retry after 5 seconds.
        setTimeout(() => {
          revalidate({ retryCount });
        }, 5000);
      },
    }
  );

  return {
    isLoading,
    error,
    data,
  };
}
